import {ApolloLink} from '@apollo/client';
import {cleanForCuro} from './utils/cleanString';

const ignoreOperations = ['UpsertReportPack'];

export const cleanForCuroLink = new ApolloLink((operation, forward) => {
  // add the recent-activity custom header to the headers
  if (ignoreOperations.includes(operation.operationName)) {
    return forward(operation);
  }
  const newVariablesStr = JSON.stringify(operation.variables);
  const newVariablesReplaced = cleanForCuro(newVariablesStr);
  if (newVariablesStr !== newVariablesReplaced) {
    // debugger;
  }
  operation.variables = JSON.parse(newVariablesReplaced);
  return forward(operation);
});
